// extracted by mini-css-extract-plugin
module.exports =  {"rating-container":"XB8f1C9","ratingContainer":"XB8f1C9","rating":"tAcR_tG","score":"ZkCIs6P","star":"di0Rw8q","count":"roYp76D"};